import React, { useState } from "react";
import {  FaMinus, FaPlus, FaVials, FaChartLine, FaClipboardCheck, FaShieldAlt, FaFileMedical, FaBalanceScale, FaCheckCircle, FaCertificate, FaGavel } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/complain.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Regulatory Affairs Specialist",
        description: "Responsible for ensuring that pharmaceutical products meet the regulatory requirements of agencies such as the FDA (U.S.), EMA (Europe), and MHRA (UK). This role involves preparing and submitting regulatory documents, supporting clinical trials with compliance guidelines, and liaising with government agencies to facilitate drug approvals. Specialists also monitor evolving regulations to ensure continuous adherence."
    },
    {
        title: "Compliance Officer",
        description: "Oversees compliance with global drug safety, quality, and legal standards to prevent regulatory violations. This role involves conducting internal audits, ensuring adherence to Good Manufacturing Practices (GMP), Good Clinical Practices (GCP), and Good Pharmacovigilance Practices (GVP). Compliance officers also manage risk assessment strategies, handle reporting requirements, and collaborate with regulatory bodies to address compliance concerns."
    },
    {
        title: "Clinical Regulatory Consultant",
        description: "Manages clinical trial regulatory submissions by ensuring documentation accuracy and adherence to global compliance standards. Responsibilities include preparing Investigational New Drug (IND) applications, Clinical Trial Applications (CTA), and ensuring timely submissions of safety reports. Consultants collaborate with regulatory agencies, ethics committees, and research teams to ensure smooth approval processes for clinical studies."
    },
    {
        title: "Quality Assurance Manager",
        description: "Ensures that drug development, manufacturing, and research processes comply with industry regulations such as GMP, GCP, and ISO standards. This role involves conducting quality audits, reviewing Standard Operating Procedures (SOPs), and addressing deviations in production or research. Quality assurance managers play a key role in minimizing risks, improving product consistency, and ensuring that final pharmaceutical products meet safety and efficacy requirements."
    }
];
const features = [
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Comprehensive regulatory strategy for seamless drug approvals." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Strict adherence to global compliance and safety standards." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Accurate and timely regulatory submissions for FDA & EMA approvals." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Good Laboratory Practice (GLP) and Good Clinical Practice (GCP) implementation." },
    { icon: <FaBalanceScale className="text-[#2a627a] text-lg" />, text: "Ethical compliance ensuring patient safety and data integrity." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Post-market surveillance for long-term drug safety monitoring." }
];

const benefits = [
    { icon: <FaCheckCircle className="text-[#2a627a] text-lg" />, text: "Ensures legal and ethical compliance in drug development." },
    { icon: <FaCertificate className="text-[#2a627a] text-lg" />, text: "Reduces the risk of regulatory penalties and product recalls." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Accelerates drug approval processes with streamlined documentation." },
    { icon: <FaBalanceScale className="text-[#2a627a] text-lg" />, text: "Enhances credibility and market trust with global compliance standards." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Protects patient rights and ensures high-quality medical treatments." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Continuous monitoring for adverse effects, improving drug safety." }
];
const cmsFeatures = [
    {
        icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />,
        title: "Regulatory Strategy & Consulting",
        text: "Expert guidance on navigating global regulatory requirements for drug approval."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        title: "Regulatory Submissions & Documentation",
        text: "Preparation and submission of dossiers for FDA, EMA, and WHO approvals."
    },
    {
        icon: <FaShieldAlt className="text-[#2a627a] text-lg" />,
        title: "Good Manufacturing Practices (GMP) Compliance",
        text: "Ensuring manufacturing quality meets global regulatory standards."
    },
    {
        icon: <FaGavel className="text-[#2a627a] text-lg" />,
        title: "Legal & Ethical Compliance",
        text: "Ensuring drugs meet ethical, legal, and environmental regulations."
    },
    {
        icon: <FaBalanceScale className="text-[#2a627a] text-lg" />,
        title: "Risk Assessment & Mitigation",
        text: "Identifying regulatory risks and implementing strategies for compliance."
    },
    {
        icon: <FaChartLine className="text-[#2a627a] text-lg" />,
        title: "Post-Market Surveillance",
        text: "Monitoring drug safety and efficacy after commercial release to ensure ongoing compliance."
    }
];
const RegulatoryCompliance = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Regulatory Compliance - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        " Upholding strict legal, ethical, and quality standards to ensure safe, effective, and trustworthy healthcare delivery."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Regulatory Compliance?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Regulatory compliance in drug development refers to adhering to legal, ethical, and safety guidelines set by 
    health authorities like the FDA, EMA, and WHO. At HIKEHEALTH GS, we ensure that all our research, clinical 
    trials, and pharmaceutical processes meet strict regulatory standards. This guarantees drug safety, efficacy, 
    and transparency, protecting both patients and healthcare professionals while facilitating smooth market approval.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Clinical Trials
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default RegulatoryCompliance;
